import { Brand } from "@/api/generated/BMWInterfaces"

// One-way brand relationships: parent name -> child names
// Ford filter includes Bronco, but Bronco filter does NOT include Ford
const BRAND_CHILDREN: Record<string, string[]> = {
  Ford: ["BRONCO"],
}

/**
 * Expands selected brand IDs to include child brand IDs.
 * e.g., if Ford is selected, Bronco's ID is also included.
 * One-directional: selecting Bronco does NOT include Ford.
 */
export function expandBrandIds(selectedIds: string[], allBrands: Brand[]): string[] {
  const expanded = new Set(selectedIds)

  for (const id of selectedIds) {
    const brand = allBrands.find((b) => b.id.toString() === id)
    if (brand && BRAND_CHILDREN[brand.name]) {
      const childNames = BRAND_CHILDREN[brand.name]
      for (const childName of childNames) {
        const childBrand = allBrands.find(
          (b) => b.name.toUpperCase() === childName.toUpperCase(),
        )
        if (childBrand) {
          expanded.add(childBrand.id.toString())
        }
      }
    }
  }

  return Array.from(expanded)
}
